import { useLocalization } from '../../../../../localization';
import { boolean, object, string } from 'yup';
import { UserRoles } from '../../../../../constants/enums/status';
import { REGEX } from 'constants/validation/regexes';
import parsePhoneNumberFromString from 'libphonenumber-js';

const firstNameValidationSchema = string();
const lastNameValidationSchema = string();
const phoneValidationSchema = string();
const emailValidationSchema = string().email();

export const inviteUserValidationSchema = () => {
  const { t } = useLocalization();
  return object().shape({
    email: string().email().required(t('validation.mixed.required')),
    departmentId: string().required(t('validation.mixed.required')),
    role: string().required().oneOf([UserRoles.USER, UserRoles.ADMIN]),
  });
};

export const updateUserValidationSchema = () => {
  const { t } = useLocalization();
  return object().shape({
    email: emailValidationSchema
      .matches(REGEX.EMAIL, t('validation.mixed.default'))
      .required(t('validation.mixed.required')),
    firstName: firstNameValidationSchema.required(t('validation.mixed.required')),
    lastName: lastNameValidationSchema.required(t('validation.mixed.required')),
    role: string().required().oneOf([UserRoles.USER, UserRoles.ADMIN]),
    phone: phoneValidationSchema
      .required(t('validation.mixed.required'))
      .test('phonePossible', t('validation.mixed.default'), val => {
        if (!val) return true;
        const p = parsePhoneNumberFromString(val);
        return !!p && p.isPossible() && p.isValid();
      }),
    showPrices: boolean(),
  });
};
